import { HOSTNAME } from '@/utils'
import type { TypeLang } from '@/schema'

const IETF_LANG: Record<TypeLang, string> = {
  es: 'es-ES',
  en: 'en-GB'
}

export const BREADCRUMB_HOME: Record<TypeLang, string> = {
  es: 'Inicio',
  en: 'Home'
}

export const BREADCRUMB_CATALOG: Record<TypeLang, string> = {
  es: 'Catálogo',
  en: 'Catalog'
}

export function getIetfLang(locale: TypeLang) { return IETF_LANG[locale] }

export function buildUrl(locale: string, path = '') {
  return `https://${HOSTNAME}${locale === 'es' ? '' : `/${locale}`}${path}`
}

/**
 * Mirrors the canonical emitted by `buildLangAlternates`, which always prefixes
 * the language, including `es`. Use this wherever the JSON-LD `url` / `@id`
 * must resolve to the same document Google indexes.
 */
export function buildCanonicalUrl(locale: string, path = '') {
  return `https://${HOSTNAME}/${locale}${path}`
}

export function buildBreadcrumb(locale: string, items: Array<{ name: string, path: string }>, urlBuilder = buildUrl) {
  return {
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.name,
      'item': urlBuilder(locale, item.path)
    }))
  }
}
